import { useState } from 'react';
import { Trans } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { HojaEncuesta } from '#components/mobile/encuesta/HojaEncuesta';
import { marcarCerrada } from '#components/mobile/encuesta/registroEncuesta';
import { Boton } from '#components/mobile/ui/Boton';
import { color, texto } from '#components/mobile/ui/tokens';

/**
 * «Encuesta de la beta» en Ajustes: la misma que ofrece Gavi a los 10 días,
 * para responderla (o cambiar lo respondido) cuando cada cual quiera.
 */
export function EncuestaSettings() {
  const [abierta, setAbierta] = useState(false);
  return (
    <View style={{ gap: 12 }}>
      <Text style={{ ...texto.cuerpo, color: color.fg2 }}>
        <Trans>
          Ten quick questions about what helps you, what is unnecessary and what
          is missing. If you already answered, you can change your answers.
        </Trans>
      </Text>
      <Boton
        bloque
        data-testid="abrir-encuesta"
        onPress={() => setAbierta(true)}
      >
        <Trans>Answer the survey</Trans>
      </Boton>
      {abierta && (
        <HojaEncuesta
          encuesta="beta"
          onCerrar={fin => {
            if (fin === 'enviada') {
              marcarCerrada('beta');
            }
            setAbierta(false);
          }}
        />
      )}
    </View>
  );
}
